var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tips"},[_c('div',{staticClass:"popup"},[_c('p',{staticClass:"content"},[_vm._v(_vm._s(_vm.current_state))])])])}
var staticRenderFns = []

export { render, staticRenderFns }